import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            精选文章
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm">
            编辑团队精心遴选的代表性文章，涵盖影史研究、经典解析与文化评论
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} variant="featured" />
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/category/fenji-zhidu"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-800 font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            浏览全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}